import {Permissions} from "@/js/Permissions";

const AdminRoutes = [
  // TODO move under settings route
  {
    path: "/admin/expedite-settings",
    name: "expedite_settings_index",
    component: () => import("@/views/admin/expediteSettings/IndexView.vue"),
    meta: {permissions: [Permissions.ADMIN, Permissions.EXPEDITE_SETTINGS]},
  },
]

export default AdminRoutes;
